import React from "react";
import { Container, Row, Col } from "reactstrap";

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer-internal">
        <Container fluid={true}>
          <Row className="footer-internal-color">
            <Col sm={12}>
              © 2026–2027 HireNeuron. All rights reserved. •{" "}
              <a href="mailto:support@hireneuron.com" className="policy_text">
                support@hireneuron.com
              </a>{" "}
              •{" "}
              <a
                href="https://hireneuron.com/privacy-policy"
                className="policy_text"
                id="as-privacy"
              >
                Privacy Policy
              </a>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
